import { render, staticRenderFns } from "./DatosAdicionales.vue?vue&type=template&id=055a602d"
import script from "./DatosAdicionales.vue?vue&type=script&lang=js"
export * from "./DatosAdicionales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports